import React, { useState, useEffect, useCallback } from 'react';
import css from './MainDashboardWrapper.css';
import Collapse from '@kunukn/react-collapse';
import {
    Menu as MenuIcon,
    Grid,
    FileText,
    ChevronDown,
    ChevronUp,
    Calendar,
    Volume2,
    Mail,
    Bell,
    PieChart,
    ChevronLeft,
    Users,
    User,
    UserPlus,
    CreditCard,
    Settings,
    List,
    Search,
    Video,
} from 'react-feather';
import { getLogoForRoute, coachLockupLogo } from '../../assets/viveka-logos';
import { Link, withRouter } from 'react-router-dom';
import config from '../../config';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Menu, MenuItem, SubMenu } from '@szhsin/react-menu';
import { logout } from '../../ducks/Auth.duck';
import defaultProfilePic from '../../assets/default_profile.png';
import { sendVerificationEmail, fetchCurrentUser } from '../../ducks/user.duck';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import { notifySuccess } from '../HotToast/HotToastProvider';
import SubscriptionExpiryBanner from '../../custom-components/elements/subscription-expiry-banner/SubscriptionExpiryBanner';
import SubscriptionMigrationBanner from '../../custom-components/elements/subscription-migration-banner/SubscriptionMigrationBanner';
import SubscribeToBeVisibleBanner from '../../custom-components/elements/subscribe-to-be-visible-banner/SubscribeToBeVisibleBanner';
import ProfileCompletenessChecklist from '../../custom-components/elements/profile-completeness-checklist/ProfileCompletenessChecklist';
import { fetchPendingEnquiriesCount } from '../../custom-ducks/clients.duck';

const MainDashboardWrapper = props => {
  const {
    currentUser,
    children,
    title,
    page,
    history,
    location,
    logout,
    onResendVerificationEmail,
    onFetchCurrentUser,
    currentUserNotificationCount,
    breadcrumbItems = [],
    currentUserHasOrders,
    unreadMessageCount,
    onFetchPendingEnquiriesCount,
  } = props;

  const [isVCorpOpen, setIsVCorpOpen] = useState(true);
  const [isVCoachOpen, setIsVCoachOpen] = useState(true);
  const [isVClientOpen, setIsVClientOpen] = useState(true);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [pendingInvitesCount, setPendingInvitesCount] = useState(0);

  const emailVerifiedRef = React.useRef(currentUser?.attributes?.emailVerified);
  emailVerifiedRef.current = currentUser?.attributes?.emailVerified;

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && emailVerifiedRef.current === false) {
        onFetchCurrentUser();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [onFetchCurrentUser]);

  const isProvider = currentUser?.attributes?.profile?.publicData?.isProvider;

  const currentCompany =
    currentUser?.attributes?.profile?.metadata[
      `currentCompany${process.env.REACT_APP_ENVIRONMENT}`
    ];
  const currentCompanyRoles = currentCompany?.roles || [];

  const showVClient =
    !isProvider || currentUserHasOrders || currentCompanyRoles.includes('employee');

  // Pending booking-enquiries count for the Bell. Sharetribe sales in
  // transition/enquire OR transition/confirm-payment.
  useEffect(() => {
    if (!isProvider || !onFetchPendingEnquiriesCount) return;
    onFetchPendingEnquiriesCount()
      .then(count => setPendingInvitesCount(count || 0))
      .catch(() => setPendingInvitesCount(0));
  }, [isProvider, onFetchPendingEnquiriesCount]);

  const isVCoachTheme =
    typeof document !== 'undefined' &&
    document.body.classList.contains('v-coach-theme');
  const menuHoverBg = isVCoachTheme ? '#7C3AED' : '#0D9488';
  const menuItemStyles = {
    color: '#0F172A',
    backgroundColor: 'white',
    hover: { backgroundColor: menuHoverBg, color: '#FFFFFF' },
    active: { backgroundColor: menuHoverBg, color: '#FFFFFF' },
  };

  const emailVerified = currentUser?.attributes?.emailVerified;

  return (
    <div className={css.base}>
      <div className={`${css.menu_base} ${isNavOpen && css.menu_open}`}>
        <div className={css.menu_nav_top}>
          <Link to={'/s'} className={css.logo}>
            <img
              style={{ width: '100%' }}
              alt={'logo'}
              src={
                page?.startsWith('coach-') ||
                (isProvider &&
                  !location.pathname.startsWith('/v-coach/client') &&
                  !location.pathname.startsWith('/employee'))
                  ? coachLockupLogo
                  : getLogoForRoute(location.pathname)
              }
            />
          </Link>
          <ChevronLeft
            className={css.menu_close_button}
            onClick={() => setIsNavOpen(false)}
          />
        </div>
        <div className={css.section_wrapper}>
          {currentCompany &&
            (currentCompanyRoles.includes('admin') || currentCompanyRoles.includes('hr')) && (
              <div className={`${css.menu_section} ${css.vcorp_section}`}>
                <div
                  className={css.menu_item_wrapper}
                  onClick={() => setIsVCorpOpen(!isVCorpOpen)}
                >
                  <p>Organization</p>
                  {isVCorpOpen ? <ChevronUp /> : <ChevronDown />}
                </div>
                <Collapse isOpen={isVCorpOpen}>
                  <a
                    href={`${config.vCorpUrl}/hr/dashboard`}
                    target="_self"
                    className={`${css.collapse_item_wrapper} ${page === 'corp-dashboard' ? css.menu_item_active : ''}`}
                  >
                    <Grid />
                    <p>Dashboard</p>
                  </a>
                  <a
                    href={`${config.vCorpUrl}/hr/curriculum`}
                    target="_self"
                    className={`${css.collapse_item_wrapper} ${page === 'corp-curriculum' ? css.menu_item_active : ''}`}
                  >
                    <FileText />
                    <p>Curriculum</p>
                  </a>
                  <a
                    href={`${config.vCorpUrl}/hr/survey`}
                    target="_self"
                    className={`${css.collapse_item_wrapper} ${page === 'corp-survey' ? css.menu_item_active : ''}`}
                  >
                    <List />
                    <p>Surveys</p>
                  </a>
                  <a
                    href={`${config.vCorpUrl}/hr/coach`}
                    target="_self"
                    className={`${css.collapse_item_wrapper} ${page === 'corp-coach' ? css.menu_item_active : ''}`}
                  >
                    <User />
                    <p>Coach</p>
                  </a>
                  <a
                    href={`${config.vCorpUrl}/hr/employee`}
                    target="_self"
                    className={`${css.collapse_item_wrapper} ${page === 'corp-employees' ? css.menu_item_active : ''}`}
                  >
                    <Users />
                    <p>Employees</p>
                  </a>
                  <a
                    href={`${config.vCorpUrl}/hr/billing/budget`}
                    target="_self"
                    className={`${css.collapse_item_wrapper} ${page === 'corp-billing' ? css.menu_item_active : ''}`}
                  >
                    <CreditCard />
                    <p>Billing</p>
                  </a>
                  <a
                    href={`${config.vCorpUrl}/hr/settings`}
                    className={`${css.collapse_item_wrapper} ${page === 'corp-settings' ? css.menu_item_active : ''}`}
                  >
                    <Settings />
                    <p>Settings</p>
                  </a>
                </Collapse>
              </div>
            )}

          {isProvider && (
            <div className={`${css.menu_section} ${css.vcoach_section}`}>
              <div
                className={css.menu_item_wrapper}
                onClick={() => setIsVCoachOpen(!isVCoachOpen)}
              >
                <p>Coach</p>
                {isVCoachOpen ? <ChevronUp /> : <ChevronDown />}
              </div>
              <Collapse isOpen={isVCoachOpen}>
                <Link
                  to={`/v-coach/clients-activities`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-dashboard' ? css.menu_item_active : ''}`}
                >
                  <Video />
                  <p>Sessions</p>
                </Link>
                <Link
                  to={`/v-coach/clients`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-clients' ? css.menu_item_active : ''}`}
                >
                  <Users size={20} />
                  <p>Clients</p>
                </Link>
                <Link
                  to={`/v-coach/reports`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-reports' ? css.menu_item_active : ''}`}
                >
                  <PieChart size={20} />
                  <p>Reports</p>
                </Link>
                <Link
                  to={`/v-coach/programs`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-program' ? css.menu_item_active : ''}`}
                >
                  <FileText />
                  <p>Programs</p>
                </Link>
                <Link
                  to={`/listings`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-ads' ? css.menu_item_active : ''}`}
                >
                  <Volume2 size={20} />
                  <p>Ads</p>
                </Link>
                <Link
                  to={`/saas-chats/coach`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-messages' ? css.menu_item_active : ''}`}
                >
                  <Mail />
                  <p>Messages</p>
                </Link>
                <Link
                  to={`/referral_program`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-referral' ? css.menu_item_active : ''}`}
                >
                  <UserPlus size={20} />
                  <p>Referrals</p>
                </Link>
                <Link
                  to={`/s`}
                  className={`${css.collapse_item_wrapper} ${page === 'client-marketplace' ? css.menu_item_active : ''}`}
                >
                  <Search size={20} />
                  <p>Find A Coach</p>
                </Link>
              </Collapse>
            </div>
          )}

          {showVClient && (
            <div className={`${css.menu_section} ${css.vclient_section}`}>
              <div
                className={css.menu_item_wrapper}
                onClick={() => setIsVClientOpen(!isVClientOpen)}
              >
                <p>Participant</p>
                {isVClientOpen ? <ChevronUp /> : <ChevronDown />}
              </div>
              <Collapse isOpen={isVClientOpen}>
                {currentCompany && (
                  <a
                    href={`${config.vCorpUrl}/employee/company/my-curriculums`}
                    className={css.collapse_item_wrapper}
                  >
                    <FileText />
                    <p>{currentCompany?.name || 'My Company'}</p>
                  </a>
                )}
                <Link
                  to={`/v-coach/client/dashboard`}
                  className={`${css.collapse_item_wrapper} ${page === 'client-dashboard' ? css.menu_item_active : ''}`}
                >
                  <Video />
                  <p>Sessions</p>
                </Link>
                <Link
                  to={`/saas-chats/client`}
                  className={`${css.collapse_item_wrapper} ${page === 'client-messages' ? css.menu_item_active : ''}`}
                >
                  <Mail />
                  <p>Messages</p>
                </Link>
                <Link
                  to={`/inbox/orders`}
                  className={`${css.collapse_item_wrapper} ${page === 'coach-orders' ? css.menu_item_active : ''}`}
                >
                  <CreditCard size={20} />
                  <p>Purchases</p>
                </Link>
              </Collapse>
            </div>
          )}

          {!isProvider && (
            <Link
              to={`/s`}
              className={`${css.collapse_item_wrapper} ${page === 'client-marketplace' ? css.menu_item_active : ''}`}
            >
              <Search size={20} />
              <p className=" text-ellipsis overflow-hidden whitespace-nowrap">Find A Coach</p>
            </Link>
          )}
        </div>
      </div>

      <div className={css.content_base}>
        <div className={css.nav_bar}>
          <MenuIcon onClick={() => setIsNavOpen(true)} />
          <div className={css.nav_title}>
            <p className="pl-2 m-0 text-xl font-semibold">{title}</p>
            <Breadcrumbs items={breadcrumbItems} />
          </div>
          <div className={css.nav_actions}>
            {isProvider && (
              <div
                style={{ position: 'relative', cursor: 'pointer', marginRight: '14px' }}
                onClick={() => history.push('/inbox/sales')}
                title="Pending client enquiries — go to Inbox to accept or decline"
              >
                <Bell className={css.nav_message_button} />
                {pendingInvitesCount > 0 && (
                  <div
                    className="animate-pulse"
                    style={{
                      position: 'absolute',
                      top: -8,
                      right: -10,
                      minWidth: 22,
                      height: 22,
                      padding: '0 6px',
                      borderRadius: 11,
                      background: '#EF4444',
                      color: '#FFFFFF',
                      fontSize: 12,
                      fontWeight: 700,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      lineHeight: 1,
                      boxShadow: '0 0 0 2px #FFFFFF, 0 2px 6px rgba(239, 68, 68, 0.45)',
                    }}
                  >
                    {pendingInvitesCount}
                  </div>
                )}
              </div>
            )}
            <div
              style={{ position: 'relative', cursor: 'pointer', marginRight: '4px' }}
              onClick={() => history.push(isProvider ? '/saas-chats/coach' : '/saas-chats/client')}
              title="Messages"
            >
              <Mail className={css.nav_message_button} />
            </div>

            <Menu
              direction="left"
              menuButton={
                <div className={css.avatar_wrapper}>
                  {/* Avatar's currentUserNotificationCount badge removed
                      per user request — the Bell already covers
                      enquiry-style notifications, and this peach pill
                      between the envelope and the avatar was reading as
                      a duplicate signal. */}
                  <div>
                    <img
                      className={css.profile_image}
                      alt="profile"
                      src={
                        currentUser?.profileImage?.attributes?.variants['square-small']?.url ||
                        defaultProfilePic
                      }
                    />
                  </div>
                  <div>
                    <p>{currentUser?.attributes?.profile.displayName}</p>
                  </div>
                </div>
              }
            >
              <MenuItem
                styles={menuItemStyles}
                onClick={() => {
                  history.push('/profile-settings');
                  return true;
                }}
              >
                Profile
              </MenuItem>
              <MenuItem
                styles={menuItemStyles}
                onClick={() => {
                  history.push('/account-settings');
                  return true;
                }}
              >
                Settings
              </MenuItem>
              <MenuItem
                styles={menuItemStyles}
                onClick={() => {
                  logout().then(() => history.push('/login'));
                  return true;
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </div>
        </div>
        <div className={css.content}>
          {currentUser && !emailVerified && (
            <div className=" p-5 mb-5 bg-slate-900 text-white rounded-[4px]">
              <h2 className="text-lg leading-tight m-0 mt-1">
                Please verify your email address!{' '}
                <span className="text-lg font-normal text-gray-400">
                  ({currentUser.attributes.email})
                </span>
              </h2>
              <p>
                To complete your registration, please check your email inbox for a
                verification message from us. If you don't see it in your inbox, it might
                have landed in your spam or junk folder. Once you find it, just click the
                verification link inside, and you'll be all set. Thank you!
              </p>
              <div
                className="bg-primary w-fit px-4 py-1 rounded-sm cursor-pointer hover:bg-primary/80 transition-all text-sm"
                onClick={() => {
                  onResendVerificationEmail().then(
                    notifySuccess(`Email Resent to ${currentUser.attributes.email}`)
                  );
                }}
              >
                Resend Email
              </div>
            </div>
          )}
          {/* Order matters here:
              1. SubscribeToBeVisibleBanner — tier 0 (no sub) inline reminder
              2. SubscriptionMigrationBanner — legacy-paid First Mover popup
              3. SubscriptionExpiryBanner — amber strip when trial/term ends soon
              Mutually exclusive in practice (tier 0 vs legacy paid vs expiring)
              but the order keeps the most permanent gate first. */}
          <SubscribeToBeVisibleBanner currentUser={currentUser} />
          <ProfileCompletenessChecklist currentUser={currentUser} />
          <SubscriptionMigrationBanner />
          <SubscriptionExpiryBanner />
          {children}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const { currentUser, currentUserNotificationCount, currentUserHasOrders } = state.user;
  const { unreadMessageCount } = state.socketChat;
  return {
    currentUser,
    currentUserNotificationCount,
    currentUserHasOrders,
    unreadMessageCount,
  };
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
  onFetchCurrentUser: () => dispatch(fetchCurrentUser()),
  onFetchPendingEnquiriesCount: () => dispatch(fetchPendingEnquiriesCount()),
});

export default withRouter(
  compose(connect(mapStateToProps, mapDispatchToProps))(MainDashboardWrapper)
);
